const getNumericFromString = (input: string): string =>
  input
    .replace(/,/g, '.') // Replacing comma with dot
    .replace(/[^\d.]/g, '')
    .replace(/\./, 'x')
    .replace(/\./g, '') // Trimming non-numeric symbols and one more dot
    .replace(/x/, '.');

export const limitByPrecision = (
  input: string | number,
  maxDecimals = 8,
): string => {
  const numeric = getNumericFromString(String(input));
  const [integer, fractional] = numeric.split('.');
  if (integer && fractional) {
    if (maxDecimals === 0) return integer;
    return `${integer}.${fractional.substring(0, maxDecimals)}`;
  }
  return numeric;
};
